import React from 'react'
import { Navigate } from 'react-router-dom'
import { userAtom } from '../stores/userAtom'
import { useAtom } from 'jotai'
import { useAuth } from '../hooks/useAuth'
import { LinearProgress } from '@mui/material'
import { UserRole } from '../types/userRoles'

interface ProtectedRouteProps {
  children: React.ReactElement
  allowedRoles: UserRole[]
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children, allowedRoles }) => {
  const { loading } = useAuth()
  const [user] = useAtom(userAtom)

  if (loading) {
    return <LinearProgress sx={{ height: '5px' }} />
  }

  if (!user) {
    return <Navigate to="/login" />
  }

  if (!user.role || !allowedRoles.includes(user.role)) {
    return <Navigate to="/" />
  }

  return <>{children}</>
}

export default ProtectedRoute
